import { Play } from "lucide-react"
import { useState } from "react"

import { useAuth } from "../../hooks/use-auth"
import { scheduledJobLabel } from "../../lib/scheduled-job-display"
import { useRunScheduledJobNow } from "../../services/use-scheduled-jobs"
import { Modal } from "../ui/modal"

export function ScheduleRunNow({ jobId, retry = false }: { jobId: string; retry?: boolean }) {
  const [isConfirming, setIsConfirming] = useState(false)
  const auth = useAuth()
  const runNow = useRunScheduledJobNow()
  const canRun = auth.user?.role === "admin" || auth.user?.role === "operator"
  const title = `Run ${scheduledJobLabel(jobId)} now?`
  return (
    <>
      <button
        className={retry ? "btn" : "btn primary"}
        disabled={!canRun}
        onClick={() => {
          runNow.reset()
          setIsConfirming(true)
        }}
      >
        {retry ? (
          "Retry now"
        ) : (
          <>
            <Play className="icon sm" />
            Run now
          </>
        )}
      </button>

      {isConfirming ? (
        <Modal
          label={title}
          onClose={() => {
            if (!runNow.isPending) {
              setIsConfirming(false)
            }
          }}
          surfaceClassName="schedule-dialog"
        >
          <h2>{title}</h2>

          <p>This starts the registered handler immediately. It does not change the cadence.</p>

          {runNow.isError ? <p role="alert">Run could not start: {runNow.error.message}</p> : null}

          <div className="dlg-actions">
            <button
              className="btn ghost"
              disabled={runNow.isPending}
              onClick={() => setIsConfirming(false)}
            >
              Cancel
            </button>

            <button
              className="btn primary"
              disabled={runNow.isPending}
              onClick={() => runNow.mutate(jobId, { onSuccess: () => setIsConfirming(false) })}
            >
              <Play className="icon sm" />

              {runNow.isPending ? "Starting…" : "Start run"}
            </button>
          </div>
        </Modal>
      ) : null}
    </>
  )
}
